import { render } from "./UpcomingCountdown.vue?vue&type=template&id=1b0f8baa&scoped=true"
import script from "./UpcomingCountdown.vue?vue&type=script&lang=js"
export * from "./UpcomingCountdown.vue?vue&type=script&lang=js"

import "./UpcomingCountdown.vue?vue&type=style&index=0&id=1b0f8baa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1b0f8baa"

export default script